export default "__VITE_ASSET__BE88KO$1__"